import { render } from "./favouriteView.vue?vue&type=template&id=49fb73be&scoped=true"
import script from "./favouriteView.vue?vue&type=script&lang=js"
export * from "./favouriteView.vue?vue&type=script&lang=js"

import "./favouriteView.vue?vue&type=style&index=0&id=49fb73be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fb73be"]])

export default __exports__